import script from "./CameraMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraMessage.vue?vue&type=script&setup=true&lang=js"

import "./CameraMessage.vue?vue&type=style&index=0&id=b5893584&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5893584"]])

export default __exports__